define('SageDotCom/DataLayer/Global/accordions',['jquery',
        'SageDotCom/DataLayer/tealium',
        'SageDotCom/DataLayer/Events/expansionClick'],
    function ($, tealium, eventSchema) {
        function globalAccordionTracking() { }

        globalAccordionTracking.prototype.initialize = function initialize() {
            $(".score-accordion-panel:not([data-xpr-state], [data-tracking]) .panel-heading").each(function (key, panel) {
                
                $(panel).click(function (event) {
                    var expanded = $('a[data-toggle]', panel).attr('aria-expanded');

                    if (typeof expanded != 'undefined') {
                        // parse direction and label explicitly
                        var direction = expanded === 'true' ? 'contract' : 'expand'; // at the time of the event, this hasn't toggled fully, so it's inverted
                        var label = $('h4', panel).text();
                        // generate event schema and fire tealium event accordingly
                        var data = eventSchema.GenerateEventMetadata(panel, direction, label);
                        tealium.event(data);
                    }
                });
                $(panel).attr('data-tracking', eventSchema.getName());
            });
        }

        return new globalAccordionTracking();
    });
